const i18n = require("@/i18n");

module.exports = {
  id: "Stylable_StylableButton_14",
  preset: { rect: { width: 148, height: 86, x: 0, y: 374 }, tags: null },
  structure: {
    parent: "comp-knzvqsjj",
    style: {
      styleType: "custom",
      componentClassName: "wixui.StylableButton",
      style: {
        groups: {},
        properties: {
          "$st-css":
            ":import{\n    -st-from: 'wix-ui-santa/index.st.css';\n    -st-named: StylableButton\n}\n.root{\n    -st-extends: StylableButton;\n    transition: all 0.2s ease, visibility 0s;\n    background: value(site_1_1);\n    border: 1px solid rgb(40, 38, 38);\n    border-width: 3px;\n    border-image: linear-gradient(90deg, #0069ff 1%, #C8D2EA 100%) 1 / 3px stretch;\n    border-radius: 0px\n}\n.root:hover {\n    background: linear-gradient(270deg, #689ade 0%, #c8d2ea 0%, #2270df 100%);\n}\n.root:hover::label {\n    color: #FFFFFF;\n}\n.root:disabled{\n    background: #E2E2E2\n}\n.root:disabled::label{\n    color: #8F8F8F\n}\n.root:disabled::icon{\n    fill: #8F8F8F\n}\n.root::container{\n    transition: inherit\n}\n.root::label{\n    transition: inherit;\n    font-style: normal;\n    color: #0069FF;\n    font-family: avenir-lt-w01_85-heavy1475544,sans-serif;\n    font-weight: 700;\n    font-size: 16px;\n    letter-spacing: 0em\n}\n.root::icon{\n    transition: inherit;\n    width: 10px;\n    height: 10px;\n    fill: value(site_1_1);\n    display: none\n}",
        },
        propertiesSource: { "$st-css": "value" },
      },
      pageId: "",
      compId: "",
      type: "ComponentStyle",
      metaData: {
        isHidden: false,
        sig: "pb4-4701",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      skin: "wixui.skins.Skinless",
    },
    activeModes: {},
    data: {
      type: "StylableButton",
      metaData: {
        isHidden: false,
        sig: "q4x-57",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      label: i18n.translate("buttons_text_preset_lets_go"),
      svgId: "b861b040274141de9c08999ec3b76edf.svg",
    },
    components: [],
    componentType: "wixui.StylableButton",
    id: "comp-km94v66a",
    layout: {
      x: 10,
      fixedPosition: false,
      y: 388,
      scale: 1,
      height: 58,
      rotationInDegrees: 0,
      width: 128,
    },
    type: "Component",
    props: {
      type: "StylableButtonProperties",
      metaData: { schemaVersion: "1.0", sig: "b80-674", pageId: "c1dmp" },
    },
    metaData: { sig: "inq-315", pageId: "c1dmp" },
    skin: "wixui.skins.Skinless",
  },
};
